import { useEffect, useState } from "react";
import { appConfig } from "../app.config";
import { AppConfigContext } from "./hooks/AppConfigContext";

const AppConfigProvider = AppConfigContext.Provider;

export default function AppConfigContainer({ children }) {
  const [config, setConfig] = useState(null);

  // Get APP config
  useEffect(() => {
    appConfig().then(setConfig);
  }, []);

  return <AppConfigProvider value={config}>{children}</AppConfigProvider>;
}
